import sample_01 from './dynamicFlameReflect.jpg';

export const dynamicFlameReflectImpressions = {
    sample_01,
};
